import React from 'react';

const ActivityCardSkeleton = () => {
  return (
    <div className="animate-pulse">
      {/* Image skeleton */}
      <div className="aspect-square rounded-xl bg-gray-100 mb-3" />

      {/* Content skeleton */}
      <div>
        <div className="flex items-start justify-between gap-2 mb-2">
          <div className="h-5 w-3/4 bg-gray-100 rounded" />
          <div className="h-5 w-10 bg-gray-100 rounded" />
        </div>
        <div className="h-4 w-1/2 bg-gray-100 rounded mb-1" />
        <div className="h-4 w-2/3 bg-gray-100 rounded mb-1" />
        <div className="h-5 w-20 bg-gray-100 rounded mt-2" />
      </div>
    </div>
  );
};

export default ActivityCardSkeleton;
